import React, { useEffect, useState } from "react";
import { HeroSection, PageRoot, StyledBreadCrumbs, StyledImage } from "./styles";
import heroBanner from "@/assets/heroBanner.png";
import Layout from "layout";
import ProductSection from "../BestSellingProductListPage/ProductSection";
import IconWithTextSection from "../BestSellingProductListPage/IconWithTextSection";
import Loader from "shared/Loader";
import { useGetProductsQuery } from "api/productApi";

const items = [
  {
    title: "Product",
  },
  {
    title: "Third Party Products",
  },
];

const ThirdPartyProductsPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search.trim()), 400);
    return () => clearTimeout(t);
  }, [search]);

  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearch]);

  const { data: thirdPartyData, isLoading } = useGetProductsQuery({
    type: "THIRD_PARTY",
    page: currentPage,
    limit: pageSize,
    searchFilter: debouncedSearch || undefined,
  });

  const handlePageChange = (page, size) => {
    if (size !== pageSize) {
      setPageSize(size);
      setCurrentPage(1);
    } else {
      setCurrentPage(page);
    }
  };

  return (
    <Layout>
      <PageRoot>
        {/* <StyledBreadCrumbs items={items} /> */}
        <HeroSection>
          <StyledImage src={heroBanner} />
        </HeroSection>
        <ProductSection
          heading="Third Party Products"
          products={thirdPartyData?.products}
          currentPage={currentPage}
          pageSize={pageSize}
          total={thirdPartyData?.total}
          onPageChange={handlePageChange}
          searchValue={search}
          onSearchChange={setSearch}
        />
        <IconWithTextSection />
        <Loader isLoading={isLoading} />
      </PageRoot>
    </Layout>
  );
};

export default ThirdPartyProductsPage;
